// Badges étape + type pour la liste/kanban dossiers.
import { cn } from '../../lib/cn';
import {
  type DossierStage,
  type DossierType,
  DOSSIER_STAGE_LABELS,
  DOSSIER_TYPE_LABELS,
} from '../../services/dossiers/dossierService';

const STAGE_CLASSES: Record<DossierStage, string> = {
  opened:         'bg-[rgba(4,52,41,0.08)] text-[#043429] border-[rgba(4,52,41,0.18)]',
  pre_litigation: 'bg-[rgba(113,128,99,0.16)] text-[#4c5842] border-[rgba(113,128,99,0.35)]',
  investigation:  'bg-[rgba(201,168,76,0.16)] text-[#7d621c] border-[#e2d3a4]',
  first_instance: 'bg-[rgba(156,91,63,0.14)] text-[#8a4a2e] border-[rgba(156,91,63,0.32)]',
  judgment:       'bg-[rgba(46,107,79,0.14)] text-[#245c41] border-[rgba(46,107,79,0.32)]',
  appeal:         'bg-[rgba(109,85,112,0.14)] text-[#5d4760] border-[rgba(109,85,112,0.32)]',
  enforcement:    'bg-[rgba(74,98,116,0.14)] text-[#3d5262] border-[rgba(74,98,116,0.32)]',
  closed:         'bg-[rgba(31,40,35,0.07)] text-[#6b746e] border-[rgba(31,40,35,0.14)]',
};

const TYPE_CLASSES: Record<DossierType, string> = {
  civil:      'bg-sky-50 text-sky-700',
  penal:      'bg-rose-50 text-rose-700',
  commercial: 'bg-amber-50 text-amber-700',
  social:     'bg-violet-50 text-violet-700',
  immobilier: 'bg-orange-50 text-orange-700',
  famille:    'bg-pink-50 text-pink-700',
  admin:      'bg-slate-50 text-slate-700',
  autre:      'bg-neutral-100 text-neutral-700',
};

export function StageBadge({ stage, className }: { stage: DossierStage; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border',
        STAGE_CLASSES[stage],
        className,
      )}
    >
      {DOSSIER_STAGE_LABELS[stage]}
    </span>
  );
}

export function TypeBadge({ type, className }: { type: DossierType; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium',
        TYPE_CLASSES[type],
        className,
      )}
    >
      {DOSSIER_TYPE_LABELS[type]}
    </span>
  );
}
